import { type ReactElement, useMemo } from 'react';
import { DataGrid, type DataGridProps } from '../primitives/DataGrid';
import { DataTableShell } from './DataTableShell';
import { wrapDataGridColumns } from './grid/wrapDataGridColumns';
import type { BaseDataTableProps } from './dataTableShared';

export const DataTableGrid = ({
  title,
  actions,
  state,
  emptyTitle,
  emptyBody,
  errorTitle,
  errorBody,
  errorAction,
  gridProps,
}: BaseDataTableProps & { gridProps: DataGridProps }): ReactElement => {
  const wrappedColumns = useMemo(
    () => wrapDataGridColumns([...gridProps.columns]),
    [gridProps.columns],
  );
  const resolvedGridProps = { ...gridProps, columns: wrappedColumns };
  const grid = <DataGrid {...resolvedGridProps} />;
  const showShell = Boolean(title) || Boolean(actions);

  if (!showShell) {
    return grid;
  }

  return (
    <DataTableShell
      title={title}
      actions={actions}
      state={state}
      emptyTitle={emptyTitle}
      emptyBody={emptyBody}
      errorTitle={errorTitle}
      errorBody={errorBody}
      errorAction={errorAction}
    >
      {grid}
    </DataTableShell>
  );
};
